import { Injectable } from '@angular/core';
import { Question, Questions, SurveySection, SurveySections } from 'models';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SurveySectionsService {

  private sections: SurveySections = undefined;
  private currentSection: SurveySection = undefined;

  onCurrentSectionChange: Subject<Question> = new Subject();

  constructor() { }
  
  createSections(): SurveySections {
    let _sections: SurveySections = [];

    // CARATT. GENERALI
    const carGenStep: SurveySection = {
      id: '1',
      label: "Caratteristiche generali",
      description: "Inserisci i criteri di ricerca e comparazione di carattere generale",
      isEnabled: true,
      isComplete: false,
      isCompleteMsgViewed: false,
      isResultSection: false,
      questions: []
    }
    _sections.push(carGenStep);

    // COPERTURE ASS.
    const copAssStep: SurveySection = {
      id: '2',
      label: "Coperture assicurative",
      description: "Inserisci i criteri di ricerca e comparazione di carattere assicurativo",
      isEnabled: false,
      isComplete: false,
      isCompleteMsgViewed: false,
      isResultSection: false,
      questions: []
    }
    _sections.push(copAssStep);

    // PRESTAZ. FINANZ.
    let preFinStep: SurveySection = {
      id: '3',
      label: "Prestazioni finanziarie",
      description: "Inserisci i criteri di carattere finanziario",
      isEnabled: false,
      isComplete: false,
      isCompleteMsgViewed: false,
      isResultSection: false,
      questions: []
    };
    _sections.push(preFinStep);

    // RISULTATO
    let resultStep: SurveySection = {
      id: '4',
      label: "Risultato",
      description: '',
      isEnabled: false,
      isComplete: false,
      isCompleteMsgViewed: false,
      isResultSection: true,
      questions: []
    };
    _sections.push(resultStep);

    this.sections = _sections;
    this.currentSection = this.sections[0];

    return _sections
  }

  resetSections() {
    this.sections = this.createSections();
    this.updateCurrentSection(this.currentSection, null);
  }

  getSections(): SurveySections {
    return this.sections ?? this.createSections()
  }

  getSectionById(fId: string): SurveySection {
    const sections = this.getSections();
    return sections.find(x => x.id == fId)
  }

  getCurrentSection(): SurveySection {
    if (!this.sections) { this.createSections(); }
    if (!this.currentSection) { this.currentSection = this.sections[0]; }
    return this.currentSection
  }

  updateCurrentSection(section: SurveySection, scrollToQuestion: Question) {
    // if (section?.id != this.currentSection?.id) {
      this.currentSection = section;
      this.onCurrentSectionChange.next(scrollToQuestion)
    // }
  }
}
